import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import '../../../../node_modules/slick-carousel/slick/slick.css';
import '../../../../node_modules/slick-carousel/slick/slick-theme.css';

import Carousel from '../../Carousel/Carousel';

import Service from './CouponsCarouselService';
import { MaxResolutions } from '../../../Shared/Helpers/Screen';

class Coupon extends React.Component {
    render() {
        let coupon = this.props.coupon;
        let couponLink = 'Special-Offers/' + coupon.id;
  
        return <section className="coupon">
            <header className="coupon-header">
                <h3>{coupon.name}</h3>
                
                {
                    coupon.image.alt == "" &&
                    <img src={coupon.image.websitePath} alt={coupon.name} />
                }
                {
                    coupon.image.alt != "" &&
                    <img src={coupon.image.websitePath} alt={coupon.image.alt} />
                }
                    
               
            </header>
            <div className="coupon-content">
                <div className="coupon-content-text">
                    <h4>{coupon.title}</h4>
                    <div className=" wysiwyg-content" dangerouslySetInnerHTML={{ __html: coupon.description }}></div>
                </div>

                <div className="coupon-footer">
                    <div className="coupon-footer-info">
                        <p><b>Offer good thru:</b> {moment(coupon.validationDate).format('MM/DD/YYYY')}</p>
                        <p><b>Valid at:</b> {coupon.dealerAddress}</p>
                    </div>
                    <a href={couponLink} className="apply-btn alert-btn">GET COUPON</a>
                    <a href={couponLink} className="coupon-btn-more">More details</a>
                </div>
            </div>
        </section >

    }
}

export default class CouponsCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            coupons: []
        };
    }

    componentDidMount() {
        Service.getCoupons().then((data) => {
            this.setState({
                coupons: data
            });
        });
    }

    render() {
        let coupons = this.state.coupons.map((coupon, index) => {
            return (<div key={index}>
                <Coupon coupon={coupon} />
            </div>);
        });

        return (<Carousel columnsAmount={this.props.columnsAmount}>
            {coupons}
        </Carousel>);
    }
}

CouponsCarousel.propTypes = {
    columnsAmount: PropTypes.number.isRequired
};


let DOMcontainers = [...document.getElementsByClassName('js-coupon-component')];

DOMcontainers.forEach((container) => {
    let columnsAmount = +container.dataset.columnsAmount;

    ReactDOM.render(<CouponsCarousel columnsAmount={columnsAmount} />,
        container);
});


// WEBPACK FOOTER //
// ./Src/Components/Coupons/CouponsCarousel/CouponsCarousel.jsx